
<div id="divForm" >
    <div id="separador" style="height:20px; background:white;" >
        <label class="labelTyping" [hidden]="!agentTyping" >Asesor escribiendo</label>
    </div>
    <label class="labelTypingOtro" [hidden]="!((!agentesDisponibles) && (positionQueue != 0))"  >
        Tu lugar para ser atendido es {{positionQueue}}</label>
    <div class="input-bar">
        <div class="input-bar-inner">
            <div class="input-bar-text-area">
            
                <textarea id="input-text"  maxlength="300" rows="2" [placeholder]="(agentesDisponibles && !fueraHorario)?'Escriba su mensaje': ''" [disabled]="(!agentesDisponibles) || cambioDeServicio || fueraHorario"
                    (keyup.enter)="sendMessage()" (focusout)="escribiendo(false)" (keydown)="escribiendo(true)" [(ngModel)]="message.content"></textarea>

                    <button [disabled]="!(message.content.length > 0) || (!agentesDisponibles) || cambioDeServicio || fueraHorario" (click)="sendMessage()" class="enviar">
                    <img src="assets/images/iconoAvion.PNG" >
                </button>
                
            </div>
            <div style="height:20px; background:white;"></div>
        </div>
    </div>
</div>